import * as types from './types';
import * as _ from 'lodash';
import moment from 'moment';

import * as withdrawTypes from './withdraw/types';
import withdrawReducer, { withdrawInitialState } from './withdraw/reducer';

import * as studentInfoTypes from './studentinfo/types';
import studentInfoReducer, {
  studentInfoInitialState,
} from './studentinfo/reducer';

import * as studentBalanceTypes from './changebalance/types';
import studentBalanceReducer, {
  studentBalanceInitialState,
} from './changebalance/reducer';

import { tabEnum } from '../helpers/AccountSetupConstants';

const prohibitedItemsInitialState = {
  prohibitedItemsLoading: false,
  initialProhibitedItemsData: [],
  prohibitedItemsData: [],
  prohibitedItemsSaving: false,
  prohibitedItemsError: null,
  prohibitedItemsSaved: false,
};

const getValidStatusCodes = (statusList) => {
  let finalList = [];
  statusList.map((status, i) => {
    finalList.push({
      key: status,
      value: status,
      text: status,
    });
    return null;
  });
  return finalList;
};

const modifyStudentObj = (studentDateData, action) => {
  if (studentDateData.BirthDate !== null) {
    studentDateData.BirthDate = moment(studentDateData.BirthDate).format(
      'MM/DD/YYYY'
    );
  }
  if (studentDateData.EffectiveDate !== null) {
    studentDateData.EffectiveDate = moment(
      studentDateData.EffectiveDate
    ).format('MM/DD/YYYY');
  }
  const finalObj = {
    Result: studentDateData,
    TotalPages: action.payload.Data.TotalPages,
    TotalRowCount: action.payload.Data.TotalRowCount,
  };
  return finalObj;
};
const validStatusInitialState = {
  validStatusMessage: [],
  validStatusLoading: false,
  validStatusFieldChanged: false,
};

const INITIAL_STATE = {
  studentData: [],
  selectedTab: tabEnum.STUDENT_INFO,
  gridLoading: false,
  studentFilter: {
    PageNumber: 1,
    PageSize: 20,
    SiteId: '',
    Filter: [],
    SortColumn: [],
    ShowWithDrawn: false,
  },
  studentInfoFilter: {
    PageNumber: 1,
    PageSize: 1,
    SiteId: '',
    Filter: [],
    SortColumn: [],
    ShowWithDrawn: false,
  },
  transactionHistoryPages: -1,
  allergenData: [],
  initialAllergenData: [],
  studentSeedData: {},
  servingNumber: undefined,
  saveStudent: '',
  allergenMessage: '',
  ...prohibitedItemsInitialState,
  studentSaving: false,
  studentInfoLoading: false,
  changeNumber: false,
  changeNumberLoading: false,
  transactionHistory: [],
  ...validStatusInitialState,
  withdraw: withdrawInitialState,
  studentBalance: studentBalanceInitialState,
  studentInfo: studentInfoInitialState,
  isNewStudent: false,
  showEditModal: false,
  billingAccountStudents:[],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ACCOUNT_SETUP_SET_IS_NEW_STUDENT:
      return {
        ...state,
        isNewStudent: action.payload,
      };
    case types.ACCOUNT_SETUP_SET_SHOW_EDIT_MODAL:
      return {
        ...state,
        showEditModal: action.payload,
      };

    case types.ACCOUNT_SETUP_GET_VALID_STATUS:
      let finalStatusObj = getValidStatusCodes(action.payload);
      return {
        ...state,
        validStatusMessage: finalStatusObj,
        validStatusFieldChanged: false,
      };

    case types.ACCOUNT_SETUP_SET_VALIDSTATUSFIELDCHANGED:
      return {
        ...state,
        validStatusFieldChanged: true,
      };

    case types.ACCOUNT_SETUP_STUDENT_SAVING:
      return {
        ...state,
        studentSaving: action.payload,
      };

    case types.ACCOUNT_SETUP_GRID_LOADING:
      return { ...state, gridLoading: action.payload };
    case types.ACCOUNT_SETUP_ROWINDEX:
      return { ...state, rowIndex: action.payload };

    case types.ACCOUNT_SETUP_GET_STUDENTS:
      action.payload.Data.Result.forEach((x) => {
        if (x.BirthDate !== null) {
          x.BirthDate = moment(x.BirthDate).format('MM/DD/YYYY');
        }
      });

      return {
        ...state,
        studentData: action.payload.Data,
      };
    case types.ACCOUNT_SETUP_GET_STUDENTS_ERROR:
      return { ...state, studentData: action.payload };

    case types.ACCOUNT_SETUP_STUDENT_FILTER:
      return { ...state, studentFilter: action.payload };
    case types.ACCOUNT_SETUP_STUDENTINFO_FILTER:
      return { ...state, studentInfoFilter: action.payload };
    case types.ACCOUNT_SETUP_STUDENTINFO_LOADING:
      return { ...state, studentInfoLoading: action.payload };
    case types.ACCOUNT_SETUP_NEW_STUDENT:
      let dateChangebleData = action.payload.Data;
      if (dateChangebleData.BirthDate !== null) {
        dateChangebleData.BirthDate = moment(
          dateChangebleData.BirthDate
        ).format('MM/DD/YYYY');
      }
      if (dateChangebleData.EffectiveDate !== null) {
        dateChangebleData.EffectiveDate = moment(
          dateChangebleData.EffectiveDate
        ).format('MM/DD/YYYY');
      }
      return {
        ...state,
        studentSeedData: dateChangebleData,
      };
    case types.ACCOUNT_SETUP_NEW_STUDENT_ERROR:
      return { ...state, studentSeedData: action.payload };
    case types.ACCOUNT_SETUP_GET_STUDENTINFO:
      let studentDateData = action.payload.Data.Result[0];
      const newStudentObj = modifyStudentObj(studentDateData, action);
      return {
        ...state,
        studentSeedData: newStudentObj,
      };
    case types.ACCOUNT_SETUP_UPDATE_STUDENTINFO:
      let studentNewData = action.payload.Data;
      const modifiedStudentObj = modifyStudentObj(studentNewData, action);
      return {
        ...state,
        studentSeedData: modifiedStudentObj,
      };
    case types.ACCOUNT_SETUP_GET_STUDENTINFO_ERROR:
      return { ...state, studentSeedData: action.payload };
    case types.ACCOUNT_SETUP_CLEAR_STUDENTINFO:
      return {
        ...state,
        studentSeedData: {},
      };
    case types.ACCOUNT_SETUP_SAVE_STUDENTINFO:
      return {
        ...state,
        saveStudent: action.payload.Data,
      };
    case types.ACCOUNT_SETUP_SAVE_STUDENTINFO_ERROR:
      return { ...state, saveStudent: false };
    case types.ACCOUNT_SETUP_POST_ALLERGENS:
      return {
        ...state,
        allergenMessage: action.payload.Data,
      };
    case types.ACCOUNT_SETUP_POST_ALLERGENS_ERROR:
      return { ...state, allergenMessage: action.payload };

    case types.ACCOUNT_SETUP_GET_SERVINGNUMBER:
      return {
        ...state,
        servingNumber: action.payload.Data,
      };
    case types.ACCOUNT_SETUP_GET_SERVINGNUMBER_ERROR:
      return { ...state, servingNumber: action.payload };
    case types.ACCOUNT_SETUP_CLEAR_SERVINGNUMBER:
      return {
        ...state,
        servingNumber: action.payload,
      };

    case types.ACCOUNT_SETUP_GET_ALLERGENS:
      return {
        ...state,
        allergenData: action.payload.Data,
        initialAllergenData: _.cloneDeep(action.payload.Data),
      };
    case types.ACCOUNT_SETUP_GET_ALLERGENS_ERROR:
      return { ...state, allergenData: action.payload };
    case types.ACCOUNT_SETUP_ALLERGEN_CHECKALL:
      let copiedData = state.allergenData.slice();
      copiedData.forEach((x) => {
        const foundRow = action.payload.currentRows.filter((row) => {
          return row._original.AllergenId === x.AllergenId;
        });
        if (foundRow.length > 0) {
          x.Assigned = action.payload.checkAll;
        }
      });
      return { ...state, allergenData: copiedData };
    case types.ACCOUNT_SETUP_ALLERGEN_DATA_CHECK:
      let newData = state.allergenData.slice();
      let item = _.find(newData, { AllergenId: action.payload.AllergenId });
      if (!item) {
        return state;
      }
      item.Assigned = action.payload.Assigned ? 0 : 1;
      return {
        ...state,
        allergenData: newData,
      };
    case types.ACCOUNT_SETUP_GET_PROHIBITED_ITEMS:
      return {
        ...state,
        prohibitedItemsData: action.payload,
        initialProhibitedItemsData: _.cloneDeep(action.payload),
      };
    case types.ACCOUNT_SETUP_PROHIBITED_ITEMS_LOADING:
      return {
        ...state,
        prohibitedItemsLoading: action.payload,
      };
    case types.ACCOUNT_SETUP_UPDATE_PROHIBITED_ITEM: {
      const { ItemId, IsProhibited } = action.payload;
      const prohibitedItemsData = _.cloneDeep(state.prohibitedItemsData);
      const item = _.find(prohibitedItemsData, { ItemId });

      item.IsProhibited = !IsProhibited;

      return {
        ...state,
        prohibitedItemsData,
      };
    }
    case types.ACCOUNT_SETUP_CHECK_ALL_PROHIBITED_ITEMS: {
      const { items, isProhibited } = action.payload;
      const prohibitedItemsData = _.cloneDeep(state.prohibitedItemsData);

      items.forEach((i) => {
        const item = _.find(prohibitedItemsData, { ItemId: i.ItemId });
        item.IsProhibited = isProhibited;
      });

      return {
        ...state,
        prohibitedItemsData,
      };
    }
    case types.ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVING:
      return {
        ...state,
        prohibitedItemsSaving: action.payload,
      };
    case types.ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVE_ERROR:
      return {
        ...state,
        prohibitedItemsError: action.payload,
      };
    case types.ACCOUNT_SETUP_PROHIBITED_ITEMS_CLEAR_ERROR:
      return {
        ...state,
        prohibitedItemsError: null,
      };
    case types.ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVE_SUCCESS:
      return {
        ...state,
        prohibitedItemsSaved: true,
      };
    case types.ACCOUNT_SETUP_PROHIBITED_ITEMS_RESET:
      return {
        ...state,
        ...prohibitedItemsInitialState,
      };

    case types.ACCOUNT_SETUP_POST_STUDENTNUMBER:
      return {
        ...state,
        changeNumber: true,
      };

    case types.ACCOUNT_SETUP_POST_STUDENTNUMBER_ERROR:
      return {
        ...state,
        changeNumber: false,
      };

    case types.ACCOUNT_SETUP_CLEAR_CHANGE_STUDENT_NUMBER:
      return {
        ...state,
        changeNumber: false,
      };

    case types.ACCOUNT_SETUP_CHANGE_STUDENT_NUMBER_LOADING:
      return {
        ...state,
        changeNumberLoading: action.payload,
      };

    case types.ACCOUNT_SETUP_GET_TRANSACTIONHISTORY:
      let { Data } = action.payload;
      if (Data) {
        Data.forEach((x) => {
          x.EffectiveDT = x.EffectiveDT
            ? moment(x.EffectiveDT).format('MM/DD/YYYY h:mm:ss A')
            : '';
          x.ActualDT = x.ActualDT
            ? moment(x.ActualDT).format('MM/DD/YYYY')
            : '';
          x.VoidDT = x.VoidedDT
            ? moment(x.VoidedDT).format('MM/DD/YYYY h:mm:ss A')
            : '';
          x.Purchase = x.Purchase.toFixed(2);
          x.Payments = x.Payments.toFixed(2);
          x.Balance = x.Balance.toFixed(2);
        });
      }
      return {
        ...state,
        transactionHistory: action.payload.Data,
        transactionHistoryPages: action.payload.Pages,
      };
    case types.ACCOUNT_SETUP_GET_TRANSACTIONHISTORY_ERROR:
      return {
        ...state,
        transactionHistory: action.payload,
      };
    case types.ACCOUNT_SETUP_CLEAR_MEALHISTORY:
      return {
        ...state,
        transactionHistory: [],
      };
    case types.ACCOUNT_SETUP_MEALHISTORY_LOADING:
      return {
        ...state,
        historyLoading: action.payload,
      };
    case types.ACCOUNT_SETUP_SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    case studentInfoTypes.ACCOUNT_SETUP_STUDENT_IMAGE_SET_STATUS:
    case studentInfoTypes.ACCOUNT_SETUP_STUDENT_IMAGE_SET_IMAGE:
    case studentInfoTypes.ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_IMAGE:
    case studentInfoTypes.ACCOUNT_SETUP_STUDENT_IMAGE_ERROR:
    case studentInfoTypes.ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_ERROR:
      return {
        ...state,
        studentInfo: studentInfoReducer(state.studentInfo, action),
      };

    case withdrawTypes.ACCOUNT_SETUP_WITHDRAW_SUCCESS:
    case withdrawTypes.ACCOUNT_SETUP_WITHDRAW_FAIL:
    case withdrawTypes.ACCOUNT_SETUP_WITHDRAW_CLEAR:
      return {
        ...state,
        withdraw: withdrawReducer(state.withdraw, action),
      };

    case studentBalanceTypes.ACCOUNT_SETUP_CLEAR_STUDENT_BALANCE_ERROR:
    case studentBalanceTypes.ACCOUNT_SETUP_GET_STUDENT_BALANCE:
    case studentBalanceTypes.ACCOUNT_SETUP_POST_STUDENT_BALANCE_SUCCESS:
    case studentBalanceTypes.ACCOUNT_SETUP_STUDENT_BALANCE_ERROR:
    case studentBalanceTypes.ACCOUNT_SETUP_STUDENT_BALANCE_FETCHING:
    case studentBalanceTypes.ACCOUNT_SETUP_STUDENT_BALANCE_RESET:
    case studentBalanceTypes.ACCOUNT_SETUP_STUDENT_BALANCE_SUBMITTING:
      return {
        ...state,
        studentBalance: studentBalanceReducer(state.studentBalance, action),
      };

    case types.ACCOUNT_SETUP_GET_BILLING_ACCOUNT_STUDENTS:
      return {
        ...state,
        billingAccountStudents: action.payload.Data,
      };

      case types.ACCOUNT_SETUP_CLEAR_BILLING_ACCOUNT_STUDENTS:
        return {
          ...state,
          billingAccountStudents: [],
        };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/reducer.js